export default __webpack_public_path__ + "static/media/pukanina1.61a7e7c4.jpg";